// extracted by mini-css-extract-plugin
export default {"board-container":"App_board-container__qulEx","tool-box":"App_tool-box__z9K+K","algortihm-selector-container":"App_algortihm-selector-container__Ixtvn"};